var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1166"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.58679 0.248474C9.90137 0.248474 12.588 2.93508 12.588 6.24965C12.588 9.56423 9.90137 12.2485 6.58915 12.2485C3.27458 12.2485 0.590334 9.56187 0.590334 6.24965C0.587973 2.93508 3.27457 0.248474 6.58679 0.248474Z",
    fill: "#8247E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_561_3754",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 9,
    height: 8
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000119824040907289936360000005545950198423505064_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4774 2.84302H2.61353V9.73422H10.4774V2.84302Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_561_3754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.15608 5.21165C8.04103 5.14564 7.89392 5.14564 7.76378 5.21165L6.84714 5.75484L6.22474 6.1L5.32508 6.6413C5.21003 6.70731 5.06291 6.70731 4.93278 6.6413L4.22927 6.21316C4.11422 6.14715 4.03312 6.01512 4.03312 5.86801V5.04568C4.03312 4.91365 4.09913 4.78352 4.22927 4.70053L4.93278 4.28936C5.04783 4.22335 5.19494 4.22335 5.32508 4.28936L6.02859 4.7175C6.14364 4.78352 6.22474 4.91554 6.22474 5.06265V5.60584L6.84714 5.24372V4.68544C6.84714 4.55341 6.78113 4.42327 6.65099 4.34029L5.34205 3.567C5.227 3.50098 5.07989 3.50098 4.94975 3.567L3.60875 4.35726C3.47861 4.42327 3.4126 4.5553 3.4126 4.68544V6.23014C3.4126 6.36216 3.47861 6.4923 3.60875 6.57529L4.93466 7.34858C5.04971 7.41459 5.19683 7.41459 5.32697 7.34858L6.22662 6.82236L6.84903 6.46024L7.74869 5.93402C7.86374 5.86801 8.01085 5.86801 8.14099 5.93402L8.8445 6.34519C8.95955 6.4112 9.04065 6.54323 9.04065 6.69034V7.51267C9.04065 7.64469 8.97464 7.77483 8.8445 7.85782L8.15797 8.26898C8.04292 8.335 7.8958 8.335 7.76566 8.26898L7.06027 7.85782C6.94522 7.79181 6.86412 7.65978 6.86412 7.51267V6.98645L6.24171 7.34858V7.89177C6.24171 8.0238 6.30773 8.15393 6.43786 8.23692L7.76378 9.01021C7.87883 9.07623 8.02594 9.07623 8.15608 9.01021L9.48199 8.23692C9.59704 8.17091 9.67814 8.03888 9.67814 7.89177V6.3301C9.67814 6.19807 9.61213 6.06793 9.48199 5.98495L8.15608 5.21165Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.77cfcc7898f53f0b05f7c5e2a5f1a2b5.svg";
export { ForwardRef as ReactComponent };